import { AxiosResponse } from 'axios';
import axiosInstance from '../utils/axios';
import amplifyConfig from '../config';
import API_PATH from './endpoints';
import type { NewsType, CreateNewsParams, UpdateNewsParams, UpdateNewsParamsClient, DeleteNewsParams } from '../types/news';

const newsAPI = {
  /**
   * 商社お知らせの取得
   * @return NewsType[]
   */
  getNewss: async () => {
    return axiosInstance.get<undefined, AxiosResponse<NewsType[]>>(amplifyConfig.apiGateway.URL + API_PATH.NEWS.NEWS_BY_TRADING_COMPANY_CODE);
  },

  /**
   * 編集用商社お知らせの取得
   * @return NewsType[]
   */
  getNewssForManage: async () => {
    return axiosInstance.get<undefined, AxiosResponse<NewsType[]>>(amplifyConfig.apiGateway.URL + API_PATH.NEWS.NEWS_TRADING_COMPANY);
  },

  /**
   * 商社お知らせの作成
   * @param CreateNewsParams
   * @return NewsType
   */
  createNews: async (params: CreateNewsParams) => {
    return axiosInstance.post<CreateNewsParams, AxiosResponse<NewsType>>(amplifyConfig.apiGateway.URL + API_PATH.NEWS.NEWS, params);
  },

  /**
   * 商社お知らせの更新
   * @param UpdateNewsParamsClient
   * @return NewsType
   */
  updateNews: async (params: UpdateNewsParamsClient) => {
    const { id, order, isDraft, title, message, publicationStartAt, publicationEndAt } = params;
    return axiosInstance.put<UpdateNewsParams, AxiosResponse<NewsType>>(amplifyConfig.apiGateway.URL + API_PATH.NEWS.NEWS + '/' + String(id), {
      order,
      isDraft,
      title,
      message,
      publicationStartAt,
      publicationEndAt,
    });
  },

  /**
   * 商社お知らせの削除
   * @param DeleteNewsParams
   * @return NewsType
   */
  deleteNews: async (params: DeleteNewsParams) => {
    const { id } = params;
    return axiosInstance.delete<DeleteNewsParams, AxiosResponse<NewsType>>(amplifyConfig.apiGateway.URL + API_PATH.NEWS.NEWS + '/' + String(id));
  },
};

export default newsAPI;
